import { SET_HEAVY_PARCEL_CONSOLIDATION_V1_FLAG, SET_USE_CORE_RATES_FLAG } from "../actions/types";

const initialState = {
  heavyParcelConsolidationV1: localStorage.getItem(SET_HEAVY_PARCEL_CONSOLIDATION_V1_FLAG) === "true",
  useCoreRates: localStorage.getItem(SET_USE_CORE_RATES_FLAG) === "true",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_HEAVY_PARCEL_CONSOLIDATION_V1_FLAG:
      localStorage.setItem(SET_HEAVY_PARCEL_CONSOLIDATION_V1_FLAG, Boolean(action.payload.value));
      return {
        ...state,
        heavyParcelConsolidationV1: Boolean(action.payload.value),
      };
    case SET_USE_CORE_RATES_FLAG:
      localStorage.setItem(SET_USE_CORE_RATES_FLAG, Boolean(action.payload.value));
      return {
        ...state,
        useCoreRates: Boolean(action.payload.value),
      };
    default:
      return state;
  }
}
